<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="130">
                <FormItem :label="$t('zh_cname')" prop="dep_cname">
                    <Input v-model="formData.dep_cname" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('tw_cname')" prop="zh-tw_cname">
                    <Input v-model="formData['zh-tw_cname']" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('en_cname')" prop="en_cname">
                    <Input v-model="formData.en_cname" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('sort')" prop="sort_id">
                    <Input v-model="formData.sort_id" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="item.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="item.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row v-if="!$base.isEmpty(this.item)">
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="item.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="item.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                op: '',
                relist: false,
                formData: {
                    dep_id:'',
                    dep_cname: '',
                    sort_id: 99,
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                    'zh-tw_cname': '',
                    en_cname: ''
                },
                rule: {
                    dep_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    'zh-tw_cname': [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    en_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                },
                item: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            if (this.$base.isEmpty(this.$base.getRequest().data)) {
                this.item = {}
            } else {
                this.item = JSON.parse(this.$base.getRequest().data)
                this.formData.dep_id = this.item.dep_id;
                this.formData.dep_cname = this.item.dep_cname;
                this.formData.en_cname = this.item.en_cname;
                this.formData['zh-tw_cname'] = this.item['zh-tw_cname'];
            }
            console.log('this.item', this.item)
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                var url = this.$base.isEmpty(this.item)?"dep/add":"dep/upd";
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/dep/dep_save.vue